// Curated six for the home Results section (correctly attributed per the master LinkedIn list)
// Display name everywhere testimonials show: first name + last initial ("Ashley A.")
export const shortName = (name) => {
  const parts = String(name).trim().split(/\s+/);
  return parts.length >= 2 ? `${parts[0]} ${parts[1][0]}.` : String(name).trim();
};

export const TESTIMONIALS = [
  {
    quote:
      "He has completely transformed my digital presence—managing everything from social media to SEO and PPC with precision, creativity, and consistency… my social media followership has grown by over 150% in just 90 days—a result that speaks for itself.",
    name: "Todd Diskin",
    role: "Owner, Fully Promoted - Olathe",
  },
  {
    quote:
      "In a matter of a few months, he has greatly improved our SEO keywords, fixed problems with our website, increased traffic to our website and most importantly substantially increased our lead flow.",
    name: "Ashley Adams",
    role: "Executive Leader | Operations, Strategy & Organizational Growth",
  },
  {
    quote:
      "Todd and his team at ZD Design Agency do what they say they are going to do, when they say they are going to do it… they provide detailed monthly reporting that has proven it, month after month.",
    name: "Kelly Vaught",
    role: "CEO at IQ Manufacturing",
  },
  {
    quote:
      "Todd is the real deal… Todd has clients that canceled the relationship with him, saw their revenues decline drastically, and then decided rehire Todd. If that doesn't show you the strength of his services, I don't know what will.",
    name: "Suyoung Cha",
    role: "Fiduciary Financial Planner",
  },
  {
    quote:
      "He is super responsive always available, his fees are very reasonable for what he offers and will identify your competitors and explain the facets of getting your business noticed quickly.",
    name: "John Gervino",
    role: "Former DHS Special Agent & Lead Interrogator",
  },
  {
    quote:
      "Todd is great to work with as he communicates well and follows through in a timely manner… it was a bit overwhelming to choose the right person, but we couldn't have chosen better!",
    name: "Katie Ramos",
    role: "DLM Commercial Real Estate Services, LLC | Tenant Rep Expert | Kansas City Native",
  },
];

// The full wall — legacy testimonials-page order first (featured, with photos),
// then every other recommendation. Photo falls back to an initials monogram.
export const ALL_TESTIMONIALS = [
  {
    quote:
      "Todd came highly recommended to us at a time where we needed a SEO coach to guide us in new marketing direction. He has exceeded even my highest expectations. In a matter of a few months, he has greatly improved our SEO keywords, fixed problems with our website, increased traffic to our website and most importantly substantially increased our lead flow. He is easy to work with as he communicates clearly and effectively around even the most complicated SEO challenge. I look forward to seeing how we continue to grow as a company with his SEO strategy and expertise.",
    img: "/img/testimonials/ashley-adams.jpg",
    name: "Ashley Adams",
    role: "Executive Leader | Operations, Strategy & Organizational Growth",
  },
  {
    quote:
      "I have worked with Todd for several months on SEO optimization and I am very impressed on the knowledge and years of experience regrading SEO and social media relating to businesses that he has imparted. He is super responsive always available, his fees are very reasonable for what he offers and will identify your competitors and explain the facets of getting your business noticed quickly.",
    img: "/img/testimonials/john-gervino.jpg",
    name: "John Gervino",
    role: "Global Science-Based Deception Detection Trainer & Consultant | Former DHS Special Agent & Lead Interrogator",
  },
  {
    quote:
      "Working with Todd is a great and he has helped me achieve my goals much faster than if I tried to do things myself. He is extremely patient and was able to understand at a glance, what my businesses needed for my online marketing, my website and SEO services. Todd is essentially an online business coach that has the background of a marketing expert. I recommend working with him one on one for great results.",
    img: "/img/testimonials/watson.jpg",
    name: "M. Watson",
    role: "Real Estate Professional at Keller Williams Realty",
  },
  {
    quote:
      "Todd is an excellent project manager! We interviewed at least a dozen web designers before signing our contract with ZD Design Agency. Todd is a true expert in his field and absolutely gets the job done on time and to your satisfaction!",
    img: "/img/testimonials/victoria-m.jpg",
    name: "Victoria M.",
    role: "Entrepreneur I Rock N Gold Creations I San Diego Gold Selling I CustomJewelry.com",
  },
  {
    quote:
      "Todd Meisler is an explosively creative designer, marketing professional and Internet developer who helped his clients reach new heights. His expertise, work ethic and competence place him at the top of his profession. He gets results.",
    img: "/img/testimonials/chris-vetter.jpg",
    name: "Chris Vetter",
    role: "Marketing, Media & Public Relations",
  },
  {
    quote:
      "Todd Meisler is a true professional and a pleasure to work with. He provides excellent service and has a varied skill set, ranging from design to marketing to consulting. Todd and his team at ZD Design Agency do what they say they are going to do, when they say they are going to do it. They work quickly, but also thoughtfully and accurately, and don't stop until each task is completed to my satisfaction. I've found working with Todd and ZD Design to be tremendously valuable. They have been consistent, reliable, and results driven. I never have to guess as to whether their services are providing gain; they provide detailed monthly reporting that has proven it, month after month. Along with working competently and professionally, Todd and his team have shown great enthusiasm in working on my projects, from day one. Bottom line, they care, and it shows. I will continue to work with Todd for the foreseeable future, and recommend him and his company for SEO, SEM, social media marketing, audits, and consulting work.",
    img: "/img/testimonials/kelly-vaught.jpg",
    name: "Kelly Vaught",
    role: "CEO at IQ Manufacturing",
  },
  {
    quote:
      "Todd has been a great connection within our industry. He has proven time and time again that he understands the complex components of SEO/SEM and is a go-getter in getting things done. I appreciate the help Todd has provided me and the influence he has had on the industry.",
    img: "/img/testimonials/stoney-degeyter.jpg",
    name: "Stoney deGeyter",
    role: "Customer Experience & Hospitality Executive | AI-Driven Innovator | Team Builder",
  },
  {
    quote:
      "Todd's company has been hired by us to revamp all of our online marketing and social media from top to bottom. Working with Todd and his company has been a pleasure. He has great knowledge of the SEO world and how to tie in all of our marketing strategies. Todd and his company are very honset and very hard working on all of our projects. If you need any SEO work done or online marketing, Todd's comany is for you. Thanks Todd for all of your company's hard work!!!",
    img: "/img/testimonials/ron-berry.jpg",
    name: "Ron Berry",
    role: "President, TSC Restoration Inc",
  },
  {
    quote:
      "Todd and his team helped us with the creation and implementation of our social media marketing program. They built the foundation of that program and also managed it until we were able to manage it internally. Overall, Todd and his team did excellent work for our company.",
    img: "/img/testimonials/timothy-moorehead.jpg",
    name: "Timothy Moorehead",
    role: "Franchise Owner at uBreakiFix at Sullivan Street, LLC",
  },
  {
    quote:
      "I am in a unique position to make this recommendation as I have dealt with Todd since I first went into the printing industry. His work is impeccable both in the graphic and web design and marketing, as well as his knowledge of SEO and social networking.",
    img: "/img/testimonials/ira-blacker.jpg",
    name: "Ira Blacker",
    role: "CEO, Printing By Design",
  },
  {
    quote:
      "Todd has helped us design and maintain our web presence, including web page design, social networking setup and recommendations. His work is accurate, fast and he is a great team player.",
    img: "/img/testimonials/arun-bajpai.jpg",
    name: "Arun Bajpai",
    role: "Dream Vacations LLC",
  },
  {
    quote:
      "My clinic hired Todd when we noticed that our online presence and the traffic being directed to our site began to decline. Unsure of the problem, Todd and his team at ZD Design did an incredible assessment of what was working and what was needed to get our website back on track. This included a full assessment of our social media, online marketing strategies and SEO needs. He and his team have helped us to not only get traffic back to our site, but come up with a long-term plan to keep our content relevant, our social media fresh, and our website a place where clients want to explore for more information. Thanks Todd!",
    img: "/img/testimonials/casey-mcguire.jpg",
    name: "Casey McGuire",
    role: "ACUPUNCTURIST, CLINIC OWNER",
  },
  {
    quote:
      "I've worked with Todd Meisler and his firm, ZD Design Agency multiple times and continue to hire his team to handle all my SEO, SEM and Social Media functions. Todd is a leader in the San Diego Search engine Marketing/Search Engine Optimization community and the most professional, from top to bottom, you can find. His agency delivers high quality results for small and medium sized businesses and stays within their budget. I highly recommend ZD Design Agency.",
    img: "/img/testimonials/jamal-brown.jpg",
    name: "Jamal Brown",
    role: "Representing Tenants in Lease & Purchase Transactions",
  },
  {
    quote:
      "Todd has done a fantastic job of helping us transform a static website into a dynamic and interactive website. We are still in the midst of this process. Todd's creativity and work is making the information we have more accessible and helping drive a lot of traffic to our site. He has good integrity and is easy to communicate with I highly recommend him and his services.",
    img: "/img/testimonials/oliver-leonetti.jpg",
    name: "Oliver Leonetti",
    role: "Acupuncturist specializing in Sports medicine, car accident recovery, and chronic pain management",
  },
  {
    quote:
      "Todd Meisler of ZD Design is a very knowledgeable and talented SEO and SEM expert. I have enjoyed our ongoing business relationship in part to his willingness to go the extra mile, provide value-added time and effort into my client's web presence, plus he is so easy to work with. His knowledge and skills as a web site designer made my job so much more easy, cost effective and, most importantly, on time. He does what he says and more.",
    img: "/img/testimonials/jeff-cameron.jpg",
    name: "Jeff Cameron",
    role: "Assistant Professor of Graphic Design at George Fox University",
  },
  {
    quote:
      "I recommend Todd for any marketing, web or creative project. During the time we worked together he made a huge impact on the company's branding, giving us a much more professional look. All while following a theme and style guide to be used company-wide for everything from emails, powerpoint presentations, to promotional materials and website.",
    img: "/img/testimonials/rudy-martinez.jpg",
    name: "Rudy Martinez",
    role: "Independent Design Professional",
  },
  {
    quote:
      "Todd is a great web consultant and having great experience in graphic design and development. As a well experienced professional, he is extremely good at driving organic traffic with his amazing SEO and SEM techniques. He takes the ownership and responsibility of the project and provides the support to the total satisfaction of the client. He is always available to work on projects and impresses me with his aesthetic design. He provides high quality service and 100% satisfaction guaranteed. I assure you that you will be totally satisfied with the quality of his services.",
    img: "/img/testimonials/john-bosco.jpg",
    name: "John Bosco. S",
    role: "USA IT Consulting & Business Development Manager",
  },
  {
    quote:
      "I've known Todd for several years through several local networking groups, and I've run across his work for local clients & competitors too. I've always been impressed by the work he's done, and with his knowledge too, and I have no hesitation recommending him for online marketing....",
    img: "/img/testimonials/scott-hendison.jpg",
    name: "Scott Hendison",
    role: "Search Commander, Inc.",
  },
  {
    quote:
      "I would highly recommend Todd for any website design, SEO work, or any other digital marketing! Todd is great to work with as he communicates well and follows through in a timely manner. With a plethora of digital marketing specialists out there, it was a bit overwhelming to choose the right person, but we couldn't have chosen better!",
    name: "Katie Ramos",
    role: "DLM Commercial Real Estate Services, LLC | Tenant Rep Expert | Kansas City Native",
  },
  {
    quote:
      "Todd is the real deal. There are so many SEO and marketing gurus out there, that it's so hard to know who to trust. There are two reasons that should tell you that you can trust Todd. Reason #1 is when you look at Todd's portfolio, it's full of clients that have been with him long term. That's a pretty darn good reason, however I love reason #2 even more. Reason #2 is that Todd has clients that canceled the relationship with him, saw their revenues decline drastically, and then decided rehire Todd. If that doesn't show you the strength of his services, I don't know what will.",
    name: "Suyoung Cha",
    role: "I am a fiduciary financial planner married to a PGY2. I help resident physicians create a list of actions steps that will help their family achive financial freedom.",
  },
  {
    quote:
      "Working with Todd at ZD Design has been a great experience. We have hit the goals at the companies with his expertise in SEO, Remarketing ads and more. I have known Todd for many years and he has never waivered from being honest, adding value and being committed to the online business marketing world. His business focus is HVAC marketing but we have worked on various projects together. From start up companies to musical projects, its a great working relationship and I highly recommend his expertise.",
    name: "Kurt Masters",
    role: "Customer Success & Technical Operations Leader in Semiconductor Manufacturing | Reducing Downtime, Improving Retention, Aligning Engineering & Field Teams",
  },
  {
    quote:
      "I cannot say enough great things about Todd Meisler from ZD Design Agency. Over the past three months, he has completely transformed my digital presence—managing everything from social media to SEO and PPC with precision, creativity, and consistency. Thanks to his efforts, my social media followership has grown by over 150% in just 90 days—a result that speaks for itself. Beyond the numbers, what stands out most is his proactive communication, deep knowledge of digital marketing trends, and ability to execute at a high level without needing to be micromanaged. He's truly on top of everything, always bringing new ideas to the table while keeping the day-to-day running smoothly. If you're looking for someone who can deliver real results and be a true partner in your business's online growth, I wholeheartedly recommend Todd and without hesitation.",
    name: "Todd Diskin",
    role: "Owner, Fully Promoted - Olathe",
  },
  {
    quote:
      "I've referred several businesses to Todd at ZD Design Agency. He has extensive knowledge of online marketing, SEO, and AI, and knows how to help businesses get the most from their marketing efforts.",
    name: "Travis Mayberry",
    role: "Financial Associate at Thrivent | Empowering individuals and families with financial clarity, guidance, and purpose-driven planning.",
  },
  {
    quote:
      "Working with Todd Meisler has been a game-changer for my business. He helped me get organized and focused on the essentials of business building, from email marketing and creating a social media calendar to optimizing my LinkedIn outreach for better appointment setting. Todd also coached me on how to network effectively at in-person events and follow up in a way that builds real relationships. What stands out most is how deeply Todd cares about your success. He asked thoughtful questions, listened intently, and tailored his guidance to my unique goals. His strategic insight and genuine support made me feel confident and equipped to grow my business with purpose. If you're looking for someone who combines marketing expertise with heart and hustle, Todd is your guy.",
    name: "Brenda Rinehart",
    role: "Helping busy adults & families protect what matters most by reducing exposure to harmful contaminants | Clean water advocate | Wellness solutions for individuals & organizations",
  },
  {
    quote:
      "I had a terrible website, and now thanks to Todd I have an awesome website! Todd made the process fast, easy and efficient and I'm thrilled with the results. I would recommend Todd in a heartbeat to anyone who needs a website built, fixed or SEO optimized.",
    name: "Jill Campbell",
    role: "Interim Accounting Solutions",
  },
  {
    quote:
      "Todd is a genius and is my go to guy when I need to gain traction in business, SEO's, web development or in social media platforms. Todd listens and can develop a plan of attack immediately. He is a sincere human and I feel secure with recommending him to anyone. If you want cutting edge education and direction...ask Todd.",
    name: "Jenny Schmidt",
    role: "Senior Investment Associate CA & FL",
  },
  {
    quote:
      "Leadership East County Master's, a program of the San Diego East County Chamber of Commerce was very lucky to have an expert like Todd speak at Technology Day and share his knowledge of online marketing optimization. The information he shared with the group was very useful and he presented it in a fun and interesting way. Todd really knows his stuff and is good at teaching it in a personable manner.",
    name: "Laura Shanahan",
    role: "Director of Operations at St. Madeleine Sophie's Center",
  },
  {
    quote:
      "Todd is a great coach and consultant to help get your online marketing in order and producing ROI on your investment. He did a great job teaching me how to measure my efforts and what's most important when looking at SEO or social media strategies. He coached me with action items that helped me get to the next step and improve my online marketing and social media efforts.",
    name: "Kiyoma Yoshizumi",
    role: "Agency Owner at Yoshizumi Insurance Agency",
  },
  {
    quote:
      "Todd is the man when it comes to SEO, social media, and marketing strategy. I've had the opportunity to work with and learn from Todd in several settings and he really gets what it takes to make a campaign succcessfuly deliver a good ROI. I most definitely reccomend Tood and personally look forward to continued collaboration with him and his agency in the future.",
    name: "Curtis Bean",
    role: "I Help Builders, Architects, Contractors, Landscapers, & Distributors Grow Their Business with Quickscreen® Premium Aluminum Fencing Systems | Modular, Fast, No-Weld Installs | Exclusive Distributor Territories Available",
  },
  {
    quote:
      "I would not hesitate to heartily recommend Todd Meisler and ZD Design for consulting, online and offline marketing optimization, SEM, and coaching for business owners. Todd's varied experiences and expertise in many areas of marketing provides value way beyond most consultants and results in objective coaching that is right on target. Todd is also a very popular host and speaker at SEM San Diego, where he brings in top experts to speak to the San Diego Marketing Community. These events are always well attended and highly appreciated. Todd is also very easy to work with.",
    name: "Mike Packard",
    role: "Senior Programmer (WordPress, MySQL)",
  },
  {
    quote:
      "Todd is a get it done type of person who we have hired in our company to rebuild our website as project manager to bring our site up to date with better result than ever. Highly recommend Todd at ZD Design as webmaster and to handle all your SEO/SEM along with Social Media to keep your business up to speed with all the internet changes.",
    name: "Simon M.",
    role: "CEO/Founder Rock N Gold Creations I CustomJewelry.com I SanDiegoGoldSelling.com Professional & Designer Precious Metals.",
  },
  {
    quote:
      "Todd was a great guy to work for. His management skills combined with his hard work ethic made ZD Design a great company to be a part of. He excelled in his creativity, but was just as savvy on the technical end. Todd worked incredibly well with clients, and had a very special way of explaining how his services really could help their company be more successful. One thing that stands out about Todd was his ability to organize a 'laid back' working environment that drove results by a hardworking crew. ZD was a great experience, and I learned a lot from Todd. I ZD Design the best in their new location... San Diego!",
    name: "Matt Earhart",
    role: "I.T. Professional (infoSec/physSec)",
  },
  {
    quote:
      "Todd designed the marketing collateral for my start-up company. He was always efficient and kept our spending costs down. Our business cards were amazing -- we got a lot of compliments. He designed other brochures for us as well -- everything was consistent and just looked good. He created original illustrations for our website too. We were always happy with his work. Thanks Todd!",
    name: "Courtney S DiCarlo",
    role: "Mover & Shaker. Community builder. Retired EA.",
  },
  {
    quote:
      "Todd went above and beyond in developing a website for our company. The communication process was flawless, and he was always giving his expertise and recommendations when needed. He also shows his extensive knowledge beyond the development process to ensure that other marketing objectives are sought after.",
    name: "Jill Jeske",
    role: "Managing operations of the TiE Oregon Investment Program and providing visibility and engagement with the startup community.",
  },
  {
    quote:
      "I've hired Todd and the ZD Design Team to re-work my website and formulate a better online marketing plan for greater visibility. Todd's knowledge and professionalism have allowed me to simply trust his proposed direction and let him do what he knows and does best. He has been nothing short of exemplary during every step of the process, keeping me abreast of what, why, and how things will be moving forward. Todd is truly a genius in his field and I look forward to a long lasting working relationship with him.",
    name: "Matt Leonetti",
    role: "Organic Compliance",
  },
  {
    quote:
      "I've known Todd for several years as someone who was a frequent attendee and participant at our SEMpdx Search Marketing Meetings in Portland. Todd's a very personable guy, very smart, and quite knowledgeable in many areas of Internet Marketing. He also has great taste in music :.) I would absolutely recommend working with Todd in any relevant professional capacity.",
    name: "Todd Mintz",
    role: "PPC, Paid Search, SEM...I'm really good at it :.) Go Blazers!",
  },
  {
    quote:
      "Todd Meisler exemplifies a quality person who knows his genre - web design and SEO. I hired Todd last year to designer my website www.coolphotomsgs.com and we worked closely for months and months. He listened to my creative ideas, collaborated and brought to life my vision. There is still more work to be done to get the word out now that the site is live and I am continuing to work with Todd on SEO to grow my business. I would highly recommend working with Todd for his expertise, his integrity and his talent.",
    name: "Evon Biondi",
    role: "Travel Content Creator | UGC Creator | Brand Spokesperson & On-Camera Storyteller | I create brand elevating video content | 20+ yrs TV commercial experience | Army Veteran",
  },
  {
    quote:
      "I hired ZD Design to clean up some marketing materials I had sourced elsewhere. Their suggestions to copy changes made my work look more professional, and their photo re-touch solved problems I did not know I even had. The final results were quickly delivered. Thanks, ZD.",
    name: "Clint Howes",
    role: "Founder at Revive Construction LLC",
  },
  {
    quote:
      "Thanks to Todd and the team at ZD Design for the redesign of my website: http://www.52perfectdays.com/. Very happy with the work and would be happy to recommend you!",
    name: "alexa meisler",
    role: "Travel Writer/owner of 52 Perfect Days & Travel in Missouri | Gluten-Free Foodie | Amazon Influencer & TikTok Creator",
  },
  {
    quote:
      "Todd Meisler has been amazing to collaborate with regarding the design and SEO of our new website service www.coolphotomsgs.com. He and his team listened to our needs, offered advice, worked in a timely manner and helped us build a great site. We have decided to continue our work with ZD Design with monthly upkeep of our site and the every needed tweaks and changes that help make a site more and more successful. I would recommend hiring ZD Design for all of your web design, SEO and creative web services needs. They know what their doing and they listen to their clients.",
    name: "Evon Biondi",
    role: "Travel Content Creator | UGC Creator | Brand Spokesperson & On-Camera Storyteller | I create brand elevating video content | 20+ yrs TV commercial experience | Army Veteran",
  },
  {
    quote:
      "Todd was an outstanding mentor while I worked as an intern in the spring of 2011. He has a wealth of knowledge and talent in web design, social media, SEO and graphic design. I enjoyed working with him and gained some great experience. I would strongly recommend Todd for any online business marketing, SEO or web design work.",
    name: "Damien Cross",
    role: "Content-Driven Web Development | SEO & AI Automation",
  },
  {
    quote:
      "Todd designed two custom Twitter backgrounds for me also created a custom Facebook page for my business, All Media Freelance, LLC. His work is incredibly creative and truly fits exactly what I wanted even though I didn't quite know how to convey my needs to him. He is accessible, friendly, and does exemplary work at a reasonable cost. I will work with Todd in the future and implore anyone who wants quality, targeted, creative design to utilize his considerable talents and design acumen.",
    name: "Samantha Gluck",
    role: "Content creator and editor at RTL Digital Media",
  },
  {
    quote:
      "Todd is very professional in his work and instruction. The time and effort he puts into every project is very inspirational. Todd's work is amazing, and makes me proud to be a member of his team at ZD Design Agency.",
    name: "Arinda Sprague",
    role: "Operations Manager & Creative Professional | Ready for a New Challenge in Customer Relations & Marketing",
  },
  {
    quote:
      "Todd has provided a user-friendly website for my photography business. He is very knowledgeable and competent with website design and implementation.",
    name: "Mike Brodwater",
    role: "Owner at Northern Exposure Photography",
  },
  {
    quote:
      "Todd is the master of detail which is so important in the fast pace world of web design. He makes sure that he is always up to speed on cutting edge web info and SEO. A pleasant person to work with and you can trust he will get the job done to your liking.",
    name: "Keith Widom",
    role: "Sales Rep at ZD Design",
  },
  {
    quote:
      "I have been working with Todd for over a year now at ZD Design and highly recommend his SEO and web design services. His business approach is very professional and in an industry where solid follow through is hard to find, Todd excels. I am so confident in Todd's services that I have even referred large clients to him when I have felt he could provide better solutions for their needs. Todd's keen eye for design and strong knowledge in marketing principles makes ZD Design a top pick for web, SEO and print related projects.",
    name: "Chris Moore",
    role: "Moore Web Exposure - Small Business Website Design",
  },
  {
    quote:
      "Todd provided great results, creative ideas and prompt service to bring my business website together. The look and feel of the site is exactly what I was looking for! I highly recommend Todd for your web design needs.",
    name: "Diane Gaston",
    role: "CTE STEAM Educator, REI Sales Specialist and In-Store events and program Presenter",
  },
  {
    quote:
      "Todd is very knowledgeable on search engine optimization and proficient with clean and efficient web design for his many clients. He's also a fun person to be around. His musical talent adds to the excitement. I look forward to collaborating more with Todd and his assistant Chris Moore.",
    name: "Mike Seng",
    role: "Strategic marketing content development and execution",
  },
  {
    quote:
      "Todd was very helpful in helping me determine what would best suit my needs and communicating my options. He has always been reliable, knowledgeable, friendly and very helpful. Current and potential clients who have received my business cards have commented on the quality of his work.",
    name: "Janene Martin, ND",
    role: "Naturopathic Doctor at Sunlight Natural Health LLC",
  },
  {
    quote:
      "Todd Meisler CEO, creative director and owner at ZD Design LLC is a excellent and outstanding SEO and web designer. Todd knows his way around web design and SEO. I highly recommend Todd Meisler at ZD design. Todd would be good on web project.",
    name: "Philip Guernsey",
    role: "Owner, stamp-sign.com",
  },
  {
    quote:
      "Todd did a great job on designing a new logo for my company. When we started I really had no idea what I wanted but Todd skillfully ascertained what I wanted and made a logo that represents what my company is all about. I highly recommend Todd and ZD Design!",
    name: "Zandy Butler",
    role: "President at On The Level Remodeling Company",
  },
  {
    quote:
      "Todd always makes all of my graphics and print material look well above average. He worked meticulously to help create what I feel is the best logo I have seen in my industry. His attention to quality and creating very high quality images for graphics has been fundamental to my continued efforts to brand this company as unique and high quality in my industry.",
    name: "Scott Avery",
    role: "We make the best wood floors in Colorado.",
  },
  {
    quote:
      "Contemtporary thinking for todays markets. Todds, freindly presonality shines through as he guides you through the possibilities of creating ways to bring a client more business. Very creative mind and his work proves that.",
    name: "Keith Widom",
    role: "Owner, Pacific Northwest Investments",
  },
  {
    quote:
      "I self published a book titled The Criminal Justice Club--A Career Prosecutor Takes on the Media--and More. I first hired Todd in 2006 to help me put the manuscript together. We worked on the manuscript for nearly one year. Todd also designed flyers and a magazine ad for my book. Todd is creative, reliable and trustworthy. His prices are reasonable. I highly recommend Todd Meisler.",
    name: "Walt Lewis",
    role: "Owner, Walbar Books",
  },
  {
    quote:
      "Todd is a great and reliable person to work with. We worked on many outstanding projects that validated the client's needs and expectations. Through Todd I was able to get my hands on a variety of exciting new projects that inquired me to explore real depths of new web standards. I'm looking forward to continuing our work together.",
    name: "Vadim Goncharov",
    role: "Software Engineer · Full Stack (Laravel / React / PostgreSQL) · AI-Assisted Development · Owner of technology & marketing at Freestyle Transport",
  },
  {
    quote:
      "Todd is a highly experienced and skilled designer and website developer. He can do a full branding program for his business clients with originality and professionalism. He has been a pleasure to work with.",
    name: "Kaya Singer",
    role: "Helping Visionary Women Entrepreneurs",
  },
  {
    quote:
      "Whenever my clients need quality printing and production services, Todd is my first call. He is responsive, trustworthy and extremely knowledgeable in the industry. If you need high quality printing, on time and within budget, Todd is your go-to guy.",
    name: "Tori Young",
    role: "Global Leader in Brand Strategy and Marketing / Fortune 100 experience / B2B and B2C",
  },
  {
    quote:
      "Todd is reliable and knowledgeable in all phases of his work. I would use his services again without question.",
    name: "Richard Meisler",
    role: "Owner, San Miguel Olive Farm",
  },
  {
    quote:
      "Todd is a great guy to work with — very creative, and with great artistic input.",
    name: "Claire Ouimet",
    role: "CEO at Artful Finishes",
  },
  {
    quote:
      "Todd is a truly exceptional print expert and all-around nice person. Every time I brought him my freelance printing challenges, he delivered quality results in a timely manner and competitive prices. I've since learned that Todd is also an amazing artist. Such talent!",
    name: "Ren Hanami",
    role: "Actress | Author | Singer | Asian Hall of Fame Inductee!",
  },
  {
    quote:
      "Working with Todd was the experience I have been waiting to have with an aritst for 20 years, someone who could translate my words and thoughts into art. It was like Todd could walk around in my brain....Terrific to work with, reasoably priced, on time, and very, very , very patient!",
    name: "Dot Nelson Turnier",
    role: "Bookkeeping, Quickbooks and Software Installations for Non Profits",
  },
  {
    quote:
      "Todd provides hands-on services, start to finish, to make your graphics make you look good. He will help you at every juncture, so it isn't an effort to make your deadline.",
    name: "Steve Ouimet",
    role: "Owner at Gigastock Images",
  },
];
